// Hilfsfunktionen: wirksame Zuweisung eines Geräts (Kap. 7.1: Gerät > Gruppe > Standort > Mandant), Wochentage.
import type { Assignment, Device, DeviceGroup } from './api/types';

export interface Effective { assignment: Assignment; via: 'device' | 'group' | 'location' | 'tenant'; viaId: string | null }

export function effectiveAssignment(d: Pick<Device, 'id' | 'locationId'>, assignments: Assignment[], groups: DeviceGroup[]): Effective | null {
  const direct = assignments.find((a) => a.targetType === 'device' && a.targetId === d.id);
  if (direct) return { assignment: direct, via: 'device', viaId: d.id };
  const myGroups = groups.filter((g) => g.deviceIds.includes(d.id)).sort((a, b) => a.name.localeCompare(b.name));
  for (const g of myGroups) {
    const a = assignments.find((x) => x.targetType === 'group' && x.targetId === g.id);
    if (a) return { assignment: a, via: 'group', viaId: g.id };
  }
  const loc = assignments.find((a) => a.targetType === 'location' && a.targetId === d.locationId);
  if (loc) return { assignment: loc, via: 'location', viaId: d.locationId };
  const t = assignments.find((a) => a.targetType === 'tenant');
  return t ? { assignment: t, via: 'tenant', viaId: null } : null;
}

/** Mo = 1 … So = 64 (schedule_rules.weekdays). */
export const WEEKDAY_BITS = [1, 2, 4, 8, 16, 32, 64];

export function deviceState(d: Pick<Device, 'status' | 'connectivity'>): 'online' | 'offline' | 'unknown' | 'revoked' {
  if (d.status === 'revoked') return 'revoked';
  return d.connectivity;
}

/** Pairing-Code tolerant normalisieren: Grossbuchstaben, ohne Trennzeichen, max. 8 Zeichen. */
export const normalizeCode = (v: string) => v.toUpperCase().replace(/[^0-9A-Z]/g, '').slice(0, 8);
export const formatCode = (v: string) => {
  const n = normalizeCode(v);
  return n.length > 4 ? `${n.slice(0, 4)}-${n.slice(4)}` : n;
};

export const PALETTE = ['#0fa89a', '#2563eb', '#d97706', '#9333ea', '#dc2626', '#0891b2', '#65a30d', '#db2777'];
